import { render, staticRenderFns } from "./SingleInboundOrderDetails.vue?vue&type=template&id=5255903e&scoped=true&lang=pug"
import script from "./SingleInboundOrderDetails.vue?vue&type=script&lang=js"
export * from "./SingleInboundOrderDetails.vue?vue&type=script&lang=js"
import style0 from "./SingleInboundOrderDetails.vue?vue&type=style&index=0&id=5255903e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5255903e",
  null
  
)

export default component.exports